import { enqueueSnackbar } from 'actions';
import { DownloadFile } from 'actions/sessionActions.js';

import {
	GetServiceIpAssignmentRequest,
	AddCellRequest
} from '../requests/ServiceIpAssignmentRequests.js';

export const GET_SERVICE_IP_ASSIGNMENT = 'GET_SERVICE_IP_ASSIGNMENT';
export const ADD_CELL = 'ADD_CELL';

export const GetServiceIpAssignment = (cellList, userName, userId) => async (dispatch) => {
	await GetServiceIpAssignmentRequest(cellList, userName, userId).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const AddCell = (cellId, region, vendor) => async (dispatch) => {
	await AddCellRequest(cellId, region, vendor).then(response => {
		dispatch(enqueueSnackbar({ message: 'Cell successfully added.', options: { variant: 'success' } }));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
